import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from './axios/axios'
import { logout } from './userSlice'

const initialState = {
  incomeReportList: [],
  incomeReportPrintList: [],
  bankData: [],
  employeeData: [],
  error: null,
  isLoading: false,
  currentPage: 0,
  totalPages: 0,
  filter: '',
}

export const getIncomeReportList = createAsyncThunk(
  'incomeReport/getIncomeReportList',
  async (obj, { rejectWithValue, fulfillWithValue, getState, dispatch }) => {
    try {
      const { user } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.user.token}`,
        },
      }
      const res = await axios.get(`/api/home/income?${obj}`, config)

      return fulfillWithValue(res.data)
    } catch (error) {
      if (error.response.status === 401 || error.response.status === 403) {
        dispatch(logout(error.response.data))
      }
      return rejectWithValue(error.response.data)
    }
  }
)

export const getIncomeReportPrintList = createAsyncThunk(
  'incomeReport/getIncomeReportPrintList',
  async (obj, { rejectWithValue, fulfillWithValue, getState, dispatch }) => {
    try {
      const { user } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.user.token}`,
        },
      }
      const res = await axios.get(`/api/print/printincomereport?${obj}`, config)

      return fulfillWithValue(res.data)
    } catch (error) {
      if (error.response.status === 401 || error.response.status === 403) {
        dispatch(logout(error.response.data))
      }
      return rejectWithValue(error.response.data)
    }
  }
)

const incomeReportSlice = createSlice({
  name: 'incomeReport',
  initialState,
  reducers: {
    resetState: (state) => {
      state.error = ''
      state.addSuccess = false
      state.updateSuccess = false
    },
  },
  extraReducers: {
    [getIncomeReportList.pending]: (state) => {
      state.isLoading = true
      state.error = ''
    },
    [getIncomeReportList.fulfilled]: (state, action) => {
      state.isLoading = false
      state.incomeReportList = action.payload.items
      state.employeeData = action.payload.EmployeeData
      state.bankData = action.payload.BankData
      state.currentPage = action.payload.currentPage
      state.totalPages = action.payload.totalPages
    },
    [getIncomeReportList.rejected]: (state, action) => {
      state.isLoading = false
      state.error = action.payload
    },
    [getIncomeReportPrintList.fulfilled]: (state, action) => {
      state.isLoading = false
      state.incomeReportPrintList = action.payload.items
      state.error = ''
      state.filter = action.payload.Filter
    },
    [getIncomeReportPrintList.rejected]: (state, action) => {
      state.isLoading = false
      state.error = action.payload
    },
  },
})

export default incomeReportSlice.reducer
